import React from "react";
import { Container, Grid } from "@material-ui/core";
import Header from "../HeaderComponent";
import CustomFooter from "./CustomFooter";
import CustomMainComponent from "./CustomMainComponent";
import CustomHeader from "./CustomHeaderComponent";

const ABHFLCustomComponent = () => {
  return (
   
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <CustomHeader style={{ justifyContent: "end", marginRight: "50px" }} />
        </Grid>
        <Grid item>
          <CustomMainComponent />
        </Grid>
        <Grid item style={{marginRight : "1%"}}>
          <CustomFooter />
        </Grid>
      </Grid>
   
  );
};

export default ABHFLCustomComponent;
